import { Injectable } from '@angular/core';
import { Context } from '../model/context';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PublicService } from '../services/public.service';

@Injectable({ providedIn: 'root' })
export class ContextResolver implements Resolve<Context> {
  
  constructor(private service: PublicService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Context>|Promise<Context>|Context {
    return this.service.getContextByGroupement(route.paramMap.get('groupement'));
  }
}